import React from 'react'

import { Dialog } from 'primereact/dialog'
import DialogFooter from '../dialogFooter'

import * as popUp from '../../components/toastr'
import CustomCalendar from '../calendar/customCalendar'
import HandleErrorService from '../../app/service/handleErrorService'
import LancarFechamentoBancarioService from '../../app/service/conciliacaoBancaria/lancarFechamentoBancarioService'
import GeneralServices from '../../app/service/generalServices'
import InputChooseTipoDeRecebimento from '../tipoDeRecebimento/inputChooseTipoDeRecebimento'
import { InputNumber } from 'primereact/inputnumber'
import { InputTextarea } from 'primereact/inputtextarea'
import ConstantsUtil from '../../context/constantsUtil'
import InputChooseContaContabil from '../planoDeContas/inputChooseContaContabil'
import InputChooseTipoDePagamento from '../contasAPagar/inputChooseTipoDePagamento'
import FormGroup from '../form-group'
import SelectMenu from '../selectMenu'
import InputChooseContaBancaria from './inputChooseContaBancaria'
import CheckBoxComponent from '../relatorios/checkBoxComponent'
import AuthService from '../../app/service/authService'

class EditLancamentoBancarioDialog extends React.Component {
    
    constructor(){
        super();
        // this.contaBancariaService = new ContaBancariaService()
        this.generalServices = new GeneralServices();
        this.lancarFechamentoBancarioService = new LancarFechamentoBancarioService();
    }

    state = {

        visible: true,

        idLancamentoFechamentoBancario: null,

        inputDateErrorClass: "",
        errorDateMessage: "",
        dataLancamento: '',
        dataLancamentoView: '',

        tipoLancamento: '',
        tipoDeLancamentoCompleto: '',
        tipoDeLancamentoBancarioOriginal: '',
        inputTipoDeLancamentoErrorClass: '',
        errorTipoDeLancamentoMessage: "Informe o Tipo de Lançamento",

        selectedTipoDeRecebimentoOuPagamento: '',
        selectedTipoDeRecebimentoOuPagamentoLabel: '',
        inputTipoDeRecebimentoErrorClass: '',
        errorTipoDeRecebimentoMessage: 'Escolha o tipo de recebimento',


        idSelectedContaBancaria: '',

        selectedContaBancariaContraPartida: '',
        selectedContaBancariaContraPartidaLabel: '',
        inputContaBancariaContraPartidaLabelErrorClass:'',

        valor: null,
        inputValorErrorClass: '',
        errorValorMessage: '',

        selectedContaContabil: '',
        selectedContaContabilLabel: '',
        inputContaContabilErrorClass:'',
        errorContaContabilMessage:'',

        historico: '',
        inputHistoricoErrorClass: '',
        errorHistoricoMessage: '',

        complementoHistorico: '',

        ofxSequence: '',

        gravarEscolha: true,

        didUpdated: false,
        allowUpdate: true,

        simpleViewTiposDePagamento: true,
    }


    componentDidUpdate(){
        this.setStates()
    }

    setStates = () => {

        // console.log("setStates")
        // console.log("this.props.visible: ", this.props.visible)
        // console.log("this.state.didUpdated: ", this.state.didUpdated)
        // console.log("this.props.forceUpdate: ", this.props.forceUpdate)
        // console.log("this.state.allowUpdate: ", this.state.allowUpdate)

        if( ((this.props.visible && !this.state.didUpdated) || this.props.forceUpdate) && this.state.allowUpdate) {

            // console.log("lanc to edit: ", this.props.state)
            // console.log("this.props.tipoDePagamentoList: ", this.props.tipoDePagamentoList)

            this.setState({visible: true})

            if(this.props.idSelectedContaBancaria){
                this.setState({idSelectedContaBancaria: this.props.idSelectedContaBancaria})
            } else{
                this.setState({idSelectedContaBancaria: this.props.state.contaBancaria.id})
            }

            this.setState({idLancamentoFechamentoBancario: this.props.state.idLancamentoFechamentoBancario})
            
            this.setState({dataLancamento: this.props.state.data})
            this.setState({dataLancamentoView: GeneralServices.convertBrStringToJsDate(this.props.state.data)})
            // this.setState({dataLancamentoView: this.props.state.dataLancamentoView})
            
            var selectedTipoDeRecebimentoOuPagamentoObj

            var partialTipoLancamento = ''
            if(this.props.tipoLancamentoBancario){
                partialTipoLancamento = this.props.tipoLancamentoBancario
            } else{
                partialTipoLancamento = this.props.state.tipoLancamentoBancario
            }

            var tipoLancamento = partialTipoLancamento
            this.setState({tipoLancamento})
            this.setState({tipoDeLancamentoCompleto: tipoLancamento})

            if(this.props.state.tipoFichaBancaria === ConstantsUtil.tipoFichaBancariaTransferenciaLabel) {
            
                this.setState({selectedContaBancariaContraPartida: {id: this.props.state.idContaBancariaContrapartida}})
                this.setState({selectedContaBancariaContraPartidaLabel: this.props.state.nomeContaBancariaContrapartida})
                
                if(partialTipoLancamento === ConstantsUtil.lancamentoBancarioRecebimentoLabel){
                    tipoLancamento = ConstantsUtil.lancamentoBancarioTransferenciaLabel
                    this.setState({tipoLancamento})
                    this.setState({tipoDeLancamentoCompleto: ConstantsUtil.lancamentoBancarioTransferenciaEntradaLabel})
                }

                else if(partialTipoLancamento === ConstantsUtil.lancamentoBancarioPagamentoLabel){
                    tipoLancamento = ConstantsUtil.lancamentoBancarioTransferenciaLabel
                    this.setState({tipoLancamento})
                    this.setState({tipoDeLancamentoCompleto: ConstantsUtil.lancamentoBancarioTransferenciaSaidaLabel})
                }
            }

            this.setState({tipoDeLancamentoBancarioOriginal: JSON.parse(JSON.stringify(tipoLancamento))})

            if(tipoLancamento === ConstantsUtil.lancamentoBancarioRecebimentoLabel){
                selectedTipoDeRecebimentoOuPagamentoObj = {id: this.props.state.idTipoDeRecebimento}
            }
            else {
                selectedTipoDeRecebimentoOuPagamentoObj = {id: this.props.state.idTipoDePagamento}
            }
            
            // console.log("1")
            if(this.props.edicaoEmLote){
                 this.setState({selectedTipoDeRecebimentoOuPagamento: ''})
                 this.setState({selectedTipoDeRecebimentoOuPagamentoLabel: ''})
            }
            else{
                this.setState({selectedTipoDeRecebimentoOuPagamento: selectedTipoDeRecebimentoOuPagamentoObj})
                this.setState({selectedTipoDeRecebimentoOuPagamentoLabel: this.props.state.descricao})
            }

            // console.log("debug: ", this.props.state)
            if(this.props.state.entrada && this.props.state.entrada !== 0){
                this.setState({valor: this.props.state.entrada})
            } else{
                this.setState({valor: this.props.state.saida})
            }

            this.setState({selectedContaContabilLabel: this.props.state.nomeContaContabil})

            this.setState({historico: this.props.state.historico})

            if(this.props.state.historico){
                // this.setState({complementoHistorico: this.props.state.historico.split(ConstantsUtil.virgulaEspacoToRegexpSplit)[1]}) //Faz split apenas do 1° achado de ", " (vírgula seguido de espaço)
                this.setState({complementoHistorico: this.props.state.historico})
            }
            else{
                this.setState({complementoHistorico: ''})
            }

            this.setState({ofxSequence: this.props.state.ofxSequence})

            this.resetView()
                
            this.setState({didUpdated: true})
            if(this.props.doneForceUpdate){
                this.props.doneForceUpdate()
            }

            // this.setState({gravarEscolha: this.props.state.gravarEscolha})
            this.setState({gravarEscolha: true})
        }
    }

    handleValorChange = (event) => {
        let value = event.value
        if(value === 0){
            value = null
        }
        const name = event.target.name
        this.setState({ [name]: value })
    }

    handleKeyPress = async (e) => {
        await this.generalServices.sleep(1) //essa função é chamada no mesmo instante que a handleValorChange.
                                            //Precisa esperar um tempo de forma que o valor seja alterado.
        //it triggers by pressing the enter key
        if (e.key === "Enter") {
            this.callSave();
        }
    }
    
    handleChange = (event) => {
        const value = event.target.value
        const name = event.target.name
        this.setState({ [name]: value })
    }

    handleNavigatorDateChange = (event, e) => {
        e.onChange(event.originalEvent, event.value)
    }

    handleDateChange = async (event) => {
        const value = event.value
        var name = event.target.name
        await this.setState({ [name]: GeneralServices.convertJSDateToBrDate(value) })
        var nameView = name+"View"
        await this.setState({ [nameView]: value })
    }

    handleTipoDeLancamentoChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ tipoLancamento: value.split("_")[0] })
        await this.setState({ tipoDeLancamentoCompleto: value })

        // console.log("2")
        this.setState({selectedTipoDeRecebimentoOuPagamento: ''})
        this.setState({selectedTipoDeRecebimentoOuPagamentoLabel: ''})

        this.setState({selectedContaBancariaContraPartida: ''})
        this.setState({selectedContaBancariaContraPartidaLabel: ''})
    }

    handleSelectionTipoDeRecebimentoChange = (tipoDeRecebimento, label) => {
        // console.log("3")
        this.setState({selectedTipoDeRecebimentoOuPagamento: tipoDeRecebimento})
        this.setState({selectedTipoDeRecebimentoOuPagamentoLabel: label})

        this.setState({selectedContaContabil: ''})
        this.setState({selectedContaContabilLabel: ''})
        
        this.setState({historico: ''})
    }

    handleSelectionTipoDePagamentoChange = (tipoDePagamento, label) => {

        // console.log("edit dialog handleSelectionTipoDePagamentoChange label: ", label)

        // console.log("4")
        this.setState({selectedTipoDeRecebimentoOuPagamento: tipoDePagamento})
        this.setState({selectedTipoDeRecebimentoOuPagamentoLabel: label})
        // console.log("handleSelectionTipoDePagamentoChange selectedTipoDeRecebimentoOuPagamentoLabel: ", this.state.selectedTipoDeRecebimentoOuPagamentoLabel)

        this.setState({selectedContaContabil: ''})
        this.setState({selectedContaContabilLabel: ''})
        
        this.setState({historico: ''})
    }

    handleSelectionContaContabilChange = (selectedContaContabil, selectedContaContabilLabel) => {
        this.setState({selectedContaContabil})
        this.setState({selectedContaContabilLabel})
    }

    handleSelectionContaBancariaContraPartidaChange = async (selectedContaBancariaContraPartida, selectedContaBancariaContraPartidaLabel) => {
        this.setState({selectedContaBancariaContraPartida})
        this.setState({selectedContaBancariaContraPartidaLabel})
    }

    hideDialog = () => {
        this.props.hideDialog()
        this.setState({didUpdated: false})
        this.setState({allowUpdate: true})
    }

    resetView = () => {
        this.setState({inputDateErrorClass: ''})
        this.setState({errorDateMessage: ''})

        this.setState({inputTipoDeLancamentoErrorClass: ''})

        this.setState({inputTipoDeRecebimentoErrorClass: ''})

        this.setState({inputTipoDePagamentoErrorClass: ''})

        this.setState({inputContaBancariaContraPartidaLabelErrorClass: ''})
        
        this.setState({inputValorErrorClass: ''})
        this.setState({errorValorMessage: ''})
        
        this.setState({inputContaContabilErrorClass: ''})
        this.setState({errorContaContabilMessage: ''})

        this.setState({inputHistoricoErrorClass: ''})
        this.setState({errorHistoricoMessage: ''})
    } 
    
    checkData = () => {
        var check = true

        if(!this.state.dataLancamento){
            this.setState({inputDateErrorClass: ConstantsUtil.primereactInputErrorClass})
            this.setState({errorDateMessage: "Informe a data"})
            check = false
        }

        if(!this.state.tipoDeLancamentoCompleto){
            this.setState({inputTipoDeLancamentoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        if(this.isTipoDeLancamentoTransferencia()){
            if(!this.state.selectedContaBancariaContraPartida){
                this.setState({inputContaBancariaContraPartidaLabelErrorClass: ConstantsUtil.bootstrapInputErrorClass})
                check = false
            }
        }

        if(this.state.tipoDeLancamentoCompleto === ConstantsUtil.lancamentoBancarioRecebimentoLabel){
            
            if(!this.state.selectedTipoDeRecebimentoOuPagamento){
                this.setState({inputTipoDeRecebimentoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
                check = false
            }

        }

        if(this.state.tipoDeLancamentoCompleto === ConstantsUtil.lancamentoBancarioPagamentoLabel){
            if(!this.state.selectedTipoDeRecebimentoOuPagamento){
                this.setState({inputTipoDePagamentoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
                check=false
            }

        }
        
        if(!this.state.valor || this.state.valor === 0){
            this.setState({inputValorErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            this.setState({errorValorMessage: "Informe o valor do lançamento"})            
            check = false
        }

        if(!this.state.selectedContaContabilLabel && this.state.selectedTipoDeRecebimentoOuPagamentoLabel.includes(ConstantsUtil.avulsoTipoDeRecebimentoLabel)){
            this.setState({inputContaContabilErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            this.setState({errorContaContabilMessage: ConstantsUtil.contaContabilErrorMessage })
            check = false
        }

        if(!this.state.historico && this.state.selectedTipoDeRecebimentoOuPagamentoLabel.includes(ConstantsUtil.avulsoTipoDeRecebimentoLabel)){
            this.setState({inputHistoricoErrorClass: ConstantsUtil.primereactInputErrorClass})
            this.setState({errorHistoricoMessage: ConstantsUtil.historicoErrorMessage })
            check = false
        }

        return check
    }

    callSave = () => {
        this.resetView()
        if(this.checkData()){
            this.save()
        }
    }

    save = () => {
        if(this.props.edicaoEmLote){
            const contasBancariasOrigemEDestino = this.getContasBancariasOrigemEDestino()
            const listaAlterada = this.props.lancamentosSelecionados.map(lancamento => this.montaObjAlteradoEmLote(lancamento, contasBancariasOrigemEDestino))

            if(this.props.fromOFX){
                this.props.editLancamentosEmLoteFromOFX(listaAlterada)
                this.hideDialog()
            }

            else if(this.props.fromFichaBancaria){
                this.updateLancamentosEmLote(listaAlterada)
            }
        
        }

        else if (this.props.fromOFX){
            this.props.editLancamentoFromOFX(this.montaObjAlterado(this.getContasBancariasOrigemEDestino()))
            this.hideDialog()
        }
        else{
            this.realSave()
        }
    }

    montaObjAlteradoEmLote = (lancamento, contasBancariasOrigemEDestino) => {
        const tipoDeRecebimentoOuPagamentoSelecionado  = this.state.selectedTipoDeRecebimentoOuPagamento
        const tipoLancamentoSelecionado = this.state.tipoLancamento

        /*
            No lote, o tipo original vem de cada lançamento selecionado.
            O tipo novo vem do select do modal e pode virar recebimento, pagamento ou transferência.
        */
        return {
            ...lancamento,
            idLancamento: lancamento.idLancamentoFechamentoBancario,
            idContaBancaria: contasBancariasOrigemEDestino.idContaOrigem,
            idContaBancariaDestino: contasBancariasOrigemEDestino.idContaDestino,
            dataCredito: lancamento.data,
            tipoDeLancamentoBancario: tipoLancamentoSelecionado,
            tipoDeLancamentoCompleto: this.state.tipoDeLancamentoCompleto,
            tipoDeLancamentoBancarioOriginal: lancamento.tipoLancamentoBancario,
            valor: lancamento.entrada || lancamento.saida,
            complementoHistorico: this.state.complementoHistorico,

            tipoDeRecebimento: tipoLancamentoSelecionado === ConstantsUtil.lancamentoBancarioRecebimentoLabel ? tipoDeRecebimentoOuPagamentoSelecionado : null,
            idTipoDeRecebimento: tipoLancamentoSelecionado === ConstantsUtil.lancamentoBancarioRecebimentoLabel ? tipoDeRecebimentoOuPagamentoSelecionado.id : null,

            tipoDePagamento: tipoLancamentoSelecionado === ConstantsUtil.lancamentoBancarioPagamentoLabel ? tipoDeRecebimentoOuPagamentoSelecionado : null,
            idTipoDePagamento: tipoLancamentoSelecionado === ConstantsUtil.lancamentoBancarioPagamentoLabel ? tipoDeRecebimentoOuPagamentoSelecionado.id : null,

            idContaContabil: this.state.selectedContaContabil?.numeroDeChamada ? parseInt(this.state.selectedContaContabil.numeroDeChamada)/5 : null,
            historicoAvulso: this.state.historico
        }
    }

    updateLancamentosEmLote = (listaAlterada) => {

        this.props.beginLoadingFichaBancariaTable()
        this.setState({allowUpdate: false})
        this.setState({visible: false})

        this.lancarFechamentoBancarioService.updateList(listaAlterada)
        .then(response => {
            popUp.successPopUp("Lançamentos bancários alterados com sucesso!")

            if(this.props.search){
                this.props.search()
            }

            this.hideDialog()
            this.setState({didUpdated: false})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            this.setState({visible: true})
        })
        .finally(() => {
            this.props.endLoadingFichaBancariaTable()
        })
    }

    getTipoDeLancamentoList = () => {
        const listaCompleta = this.lancarFechamentoBancarioService.tipoDeLancamentoList 

        if(AuthService.getPerfil().isOperadorPagamentoDinheiro){
            return listaCompleta.filter(item =>
                item.value === ConstantsUtil.lancamentoBancarioPagamentoLabel
            )
        }

        /*
            A lista é filtrada pelo sentido original do lançamento.
            Recebimento pode virar entrada; pagamento pode virar saída.
        */
        if(this.state.tipoDeLancamentoBancarioOriginal === ConstantsUtil.lancamentoBancarioRecebimentoLabel){
            return listaCompleta.filter(item =>
                item.value === '' ||
                item.value === ConstantsUtil.lancamentoBancarioRecebimentoLabel ||
                item.value === ConstantsUtil.lancamentoBancarioTransferenciaEntradaLabel
            )
        }   

        if(this.state.tipoDeLancamentoBancarioOriginal === ConstantsUtil.lancamentoBancarioPagamentoLabel){
            return listaCompleta.filter(item =>
                item.value === '' ||
                item.value === ConstantsUtil.lancamentoBancarioPagamentoLabel ||
                item.value === ConstantsUtil.lancamentoBancarioTransferenciaSaidaLabel
            )
        }   

        return listaCompleta
    }

    
    realSave = () => {

        this.props.beginLoadingFichaBancariaTable()
        this.setState({allowUpdate: false})
        this.setState({visible: false})
        let objAlterado = this.montaObjAlterado(this.getContasBancariasOrigemEDestino())
        this.lancarFechamentoBancarioService.update(objAlterado)
        .then(response => {
            popUp.successPopUp("Lançamento bancário alterado com sucesso!")
            if(this.props.search){
                this.props.search()
            }
            this.hideDialog()
            this.setState({didUpdated: false})
            this.props.endLoadingFichaBancariaTable()
        }).catch(error => {
            // console.log("error: ", error)
            this.props.endLoadingFichaBancariaTable()
            HandleErrorService.handleError(error)
            this.setState({visible: true})
        })
        this.setState({didUpdated: false})
    }

    getContasBancariasOrigemEDestino = () => {
        //Já popula para o caso de não ser transferência
        var idContaOrigem = this.state.idSelectedContaBancaria;
        var idContaDestino= '';

        if(this.isTipoDeLancamentoTransferenciaEntrada()){
            idContaOrigem = this.state.selectedContaBancariaContraPartida.id
            // idContaDestino = this.props.idSelectedContaBancaria
            idContaDestino = this.state.idSelectedContaBancaria
        }
        else if(this.isTipoDeLancamentoTransferenciaSaida()){
            // idContaOrigem = this.props.idSelectedContaBancaria
            idContaOrigem = this.state.idSelectedContaBancaria
            idContaDestino = this.state.selectedContaBancariaContraPartida.id
        }

        return {idContaOrigem, idContaDestino}
    }

    montaObjAlterado = (constasBancariasOrigemEDestinoObj) => {
        // console.log("this.state.selectedTipoDeRecebimentoOuPagamento: ", this.state.selectedTipoDeRecebimentoOuPagamento)
        
        let idContaOrigem = constasBancariasOrigemEDestinoObj.idContaOrigem
        let idContaDestino = constasBancariasOrigemEDestinoObj.idContaDestino

        const obj = {
            idLancamento: this.state.idLancamentoFechamentoBancario,
            dataCredito: this.state.dataLancamento,
            tipoDeLancamentoBancario: this.state.tipoLancamento,
            tipoDeLancamentoCompleto: this.state.tipoDeLancamentoCompleto,
            tipoDeLancamentoBancarioOriginal: this.state.tipoDeLancamentoBancarioOriginal,
            tipoTransacaoOFX: this.props.state.tipoTransacaoOFX,

            idTipoDeRecebimento: this.state.tipoLancamento === ConstantsUtil.lancamentoBancarioRecebimentoLabel ? 
                this.state.selectedTipoDeRecebimentoOuPagamento.id : null,

            tipoDeRecebimento: this.state.tipoLancamento === ConstantsUtil.lancamentoBancarioRecebimentoLabel ? 
            this.state.selectedTipoDeRecebimentoOuPagamento : null, 

            idTipoDePagamento: this.state.tipoLancamento === ConstantsUtil.lancamentoBancarioPagamentoLabel ? 
                this.state.selectedTipoDeRecebimentoOuPagamento.id : null,

            tipoDePagamento: this.state.tipoLancamento === ConstantsUtil.lancamentoBancarioPagamentoLabel ? 
                this.state.selectedTipoDeRecebimentoOuPagamento : null,

            idContaBancaria: idContaOrigem,
            idContaBancariaDestino: idContaDestino, //será utilizado pelo backend apenas quando se tratar de transferência
            idContaBancariaContrapartida: this.state.selectedContaBancariaContraPartida.id,
            nomeContaBancariaContrapartida: this.state.selectedContaBancariaContraPartidaLabel,
            complementoHistorico: this.state.complementoHistorico,
            ofxSequence: this.state.ofxSequence,
            valor: this.state.valor,

            gravarEscolha: this.state.gravarEscolha,
            descricaoOFX: this.props.state?.descricaoOFX,

            /*
                Os dois abaixo são utilizados pelo backend apenas quando se trata de um lancamento de fechamento bancário
                do Tipo de Recebimento AVULSO.
            */
            idContaContabil: parseInt(this.state.selectedContaContabil.numeroDeChamada)/5,
            historicoAvulso: this.state.historico
        }

        // console.log("this.state: ", this.props.state)
        // console.log("montaObjAlterado final: ", obj)

        return obj
    }
    
    isTipoDeLancamentoTransferencia = () => {
        return this.state.tipoLancamento === ConstantsUtil.lancamentoBancarioTransferenciaLabel
    }

    isTipoDeLancamentoTransferenciaEntrada = () => {
        return this.isTipoDeLancamentoTransferencia()
        && (this.state.tipoDeLancamentoCompleto === ConstantsUtil.lancamentoBancarioTransferenciaEntradaLabel)
    }

    isTipoDeLancamentoTransferenciaSaida = () => {
        return this.isTipoDeLancamentoTransferencia()
        && (this.state.tipoDeLancamentoCompleto === ConstantsUtil.lancamentoBancarioTransferenciaSaidaLabel)
    }

    // onRenderTipoDeRecebimentoDialog = () => {
    //     this.setState({visible: false})
    // }

    // onCloseTipoDeRecebimentoDialog = () => {
    //     this.setState({visible: true})
    // }
    
    filtroContaBancaria = () => {
        let filtro = {
            idContaBancaria: this.state.idSelectedContaBancaria,
            excluiInativos: true,
        }
        return filtro
    }    


    render () {

        const editTipoRecebimentoDialogFooter = (
            <DialogFooter save = {this.callSave} hideDialog = {this.hideDialog} disabled={this.props.disabled}/>
        )

        const renderInputChooseContaContabil = () => {
            // console.log("renderInputChooseContaContabil: ", this.state.selectedTipoDeRecebimentoOuPagamentoLabel)
            if(
                this.state.selectedTipoDeRecebimentoOuPagamentoLabel.includes(ConstantsUtil.avulsoTipoDeRecebimentoLabel)
                ||
                this.state.selectedTipoDeRecebimentoOuPagamentoLabel.includes(ConstantsUtil.avulsoTipoDePagamentoLabel)
            )
            return (
                <>
                <InputChooseContaContabil
                    noHTMLFormat
                    selectedContaContabilLabel={this.state.selectedContaContabilLabel}
                    tipoLancamentoBancario={this.state.tipoLancamento}
                    handleSelectionContaContabilChange={this.handleSelectionContaContabilChange}
                    inputContaContabilErrorClass={this.state.inputContaContabilErrorClass}
                    errorContaContabilMessage={this.state.errorContaContabilMessage}
                />

                <br />

                </>
            )
        }

        const renderHistoricoTextArea = () => {
            if(
                this.state.selectedTipoDeRecebimentoOuPagamentoLabel.includes(ConstantsUtil.avulsoTipoDeRecebimentoLabel)
                ||
                this.state.selectedTipoDeRecebimentoOuPagamentoLabel.includes(ConstantsUtil.avulsoTipoDePagamentoLabel)
            )
            return(
                <>
                <div className="p-field">
                <label htmlFor="icon">Histórico</label>
                    <InputTextarea
                        className={this.state.inputHistoricoErrorClass}
                        value={this.state.historico}
                        onChange={(e) => this.setState({historico: e.target.value})}
                        onKeyDown={this.handleKeyPress}
                        rows={5} cols={35}
                        autoResize
                        // disabled={this.state.selectedTipoDeRecebimentoOuPagamentoLabel !== ConstantsUtil.avulsoTipoDeRecebimentoLabel}
                    />
                    <small id="historicoError" className="p-error">{this.state.errorHistoricoMessage}</small>
                </div>
                </>
            )
        }

        const renderComplementoDeHistorico = () => {
            if(
                (
                    this.state.tipoLancamento === ConstantsUtil.lancamentoBancarioPagamentoLabel
                    &&
                    this.state.selectedTipoDeRecebimentoOuPagamentoLabel !== ConstantsUtil.avulsoTipoDePagamentoLabel
                )
                ||
                (
                    this.state.tipoLancamento === ConstantsUtil.lancamentoBancarioRecebimentoLabel
                    &&
                    this.state.selectedTipoDeRecebimentoOuPagamentoLabel !== ConstantsUtil.avulsoTipoDeRecebimentoLabel
                )
            ){
                return (
                    <div className="p-field">
                    <label htmlFor="icon">Complemento de Histórico (Opcional)</label>
                    <InputTextarea
                        ref={this.complementoHistoricoRef}
                        className={this.state.inputComplementoHistoricoErrorClass}
                        value={this.state.complementoHistorico}
                        onChange={(e) => this.setState({complementoHistorico: e.target.value})}
                        rows={5} cols={35}
                        autoResize
                    />
                    </div>
                )
            }
        }        

        const renderContaBancariaContraPartidaInput = () => {
            if(this.isTipoDeLancamentoTransferencia())
            return (
                <>
                <div className="p-field">
                   <InputChooseContaBancaria
                        label={GeneralServices.getContaBancariaOrigemOuDestinoLabel(false, this.isTipoDeLancamentoTransferencia, this.isTipoDeLancamentoTransferenciaEntrada)}
                        readOnly
                        excludeAplicacaoFinanceira
                        // autofocus
                        // forceShowDialog={this.state.forceShowContaBancariaDialog}
                        // doNotForceContaBancariaDialog={this.doNotForceContaBancariaDialog}
                        selectedContaBancariaLabel={this.state.selectedContaBancariaContraPartidaLabel}
                        handleSelectionContaBancariaChange={this.handleSelectionContaBancariaContraPartidaChange}
                        inputContaBancariaErrorClass={this.state.inputContaBancariaContraPartidaLabelErrorClass}
                        noHTMLFormat
                    />
                </div>
                </>
                    
            )
        }

        const renderInputTipoDeRecebimentoOuPagamento = () => {

            if(!this.props.state){
                return
            }

            if(this.state.tipoDeLancamentoCompleto === ConstantsUtil.lancamentoBancarioRecebimentoLabel){
                return (
                    <>
                        <br />
                        <InputChooseTipoDeRecebimento
                            selectedTipoDeRecebimentoLabel={this.state.selectedTipoDeRecebimentoOuPagamentoLabel}
                            selectedTipoDeRecebimento={this.state.selectedTipoDeRecebimentoOuPagamento}
                            simpleView
                            enableCadastrarButtonInSimpleView
                            tipoDeRecebimentoList={this.props.tipoDeRecebimentoList}
                            contaBancariaId={this.state.idSelectedContaBancaria}
                            noHTMLFormat
                            handleSelectionTipoDeRecebimentoChange={this.handleSelectionTipoDeRecebimentoChange}
                            inputTipoDeRecebimentoErrorClass={this.state.inputTipoDeRecebimentoErrorClass}
                            errorTipoDeRecebimentoMessage={this.state.errorTipoDeRecebimentoMessage}
                            fromOFX={this.props.fromOFX}
                        />
                    </>
                )
            } else if(this.state.tipoDeLancamentoCompleto === ConstantsUtil.lancamentoBancarioPagamentoLabel){
                return (
                    <>

                        <br />
                        
                        <InputChooseTipoDePagamento
                            selectedTipoDePagamentoLabel={this.state.selectedTipoDeRecebimentoOuPagamentoLabel}
                            selectedTipoDePagamento={this.state.selectedTipoDeRecebimentoOuPagamento}
                            simpleView={this.state.simpleViewTiposDePagamento}
                            enableCadastrarButtonInSimpleView
                            filtroContaBancaria={this.filtroContaBancaria()}                        
                            noHTMLFormat
                            tipoDePagamentoList={this.props.tipoDePagamentoList}
                            contaBancariaId={this.state.idSelectedContaBancaria}
                            handleSelectionTipoDePagamentoChange={this.handleSelectionTipoDePagamentoChange}
                            inputTipoDePagamentoErrorClass={this.state.inputTipoDePagamentoErrorClass}
                            onFinishSearchTipoDePagamentoList={this.props.onFinishSearchTipoDePagamentoList}
                        />
                    </>
                )
            }
        }

        const renderCheckBoxMarcarTipoDeRecebimentoOuPagamento = () => {
            if(this.props.fromOFX || this.props.state?.descricaoOFX){
                return (
                    <>
                    <br />
                    <CheckBoxComponent
                        label="Gravar Escolha Acima?"
                        checked={this.state.gravarEscolha}
                        handleCheckBoxChange={(checked) => this.setState({gravarEscolha: checked})}
                    />
                    {/* <br /> */}
                    </>
                )
            }
        }

        const renderDataInput = () => {
            if(!this.props.edicaoEmLote){
                return (
                    <>
                        <div className="p-field">
                            <CustomCalendar
                                id="lancamentoDate"
                                htmlFor="dataLancamentoInicio"
                                label="Data"
                                inputDateErrorClass={this.state.inputDateErrorClass}
                                value={this.state.dataLancamentoView}
                                name="dataLancamento"
                                onChange={this.handleDateChange}
                                noHTMLFormat
                                // disabled={!this.state.habilitaBusca}
                                errorDateMessage={this.state.errorDateMessage}
                            />
                        </div>
                    
                    </>
                )
            }
        }

        const renderTipoLancamento = () => {
                return (
                    <>
                        <div className="p-field">
                            <FormGroup label = "Tipo de Lançamento " htmlFor = "InputTipoLancamento">
                                <SelectMenu
                                id="selectTipoLancamento"
                                className={"form-control " + this.state.inputTipoDeLancamentoErrorClass}
                                // ref={this.tipoDeLancamentoInputRef}
                                name="tipoLancamento"
                                list={this.getTipoDeLancamentoList()} 
                                value={this.state.tipoDeLancamentoCompleto}
                                onChange={this.handleTipoDeLancamentoChange}
                                disabled={AuthService.getPerfil().isOperadorPagamentoDinheiro}
                                /> 
                                <div className="invalid-feedback">{this.state.errorTipoDeLancamentoMessage}</div>  
                            </FormGroup> 
                        </div>
                    </>
                )
        }

        const renderValorDoLancamento = () => {
            if(!this.props.edicaoEmLote){
                return (
                    <>
                        <div className="p-field">
                            <label htmlFor="valor">Valor do Lançamento</label>
                            <InputNumber 
                                className={this.state.inputValorErrorClass}
                                name="valor"
                                inputId="valorFechamentoBancario"
                                value={this.state.valor}
                                onValueChange={this.handleValorChange}
                                onKeyDown={this.handleKeyPress}
                                // mode="currency" currency="BRL" locale="pt-BR"
                                mode="decimal" locale="pt-BR" minFractionDigits={2}
                            />
                            <small id="valorError" className="p-error">{this.state.errorValorMessage}</small>
                        </div>
                    </>
                )
            }
        }

        

        return (
            <>
            <Dialog
                visible={this.props.visible && this.state.visible}
                style={{ width: '450px' }}
                header={this.props.header}
                modal
                className="p-fluid"
                footer={editTipoRecebimentoDialogFooter}
                onHide={this.hideDialog}
            >
               {renderDataInput()}

                <br />

               {renderTipoLancamento()} 

                

                <div className="p-field">
                    {renderInputTipoDeRecebimentoOuPagamento()}

                    <br />

                    {renderContaBancariaContraPartidaInput()}

                    <div className='col-md-12'>
                        {renderCheckBoxMarcarTipoDeRecebimentoOuPagamento()}
                    </div>                    

                </div>

                <br />
                
                {renderValorDoLancamento()}

                <br />
                
                {renderInputChooseContaContabil()}

                {renderHistoricoTextArea()}

                {renderComplementoDeHistorico()}
                

            </Dialog>
            
            </>

        )
    }
}

export default EditLancamentoBancarioDialog
